import type { ReadonlyDeep } from 'type-fest';

import {
  ActorOrganizationInput,
  ActorPersonInput,
  ActorTypeEnum,
} from '@e-socna/data-layer';
import type { ActorUnionInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { ActorForm_Actor } from '../fragments/actor.fragment';

import { externalReferenceForm2ApiMapper } from './external-reference.form2api.mapper';
import { representativeForm2ApiMapper } from './representative.form2api.mapper';

export function actorForm2ApiMapper(
  actor: ReadonlyDeep<ActorForm_Actor>,
): ActorUnionInput {
  let actorInput: ActorUnionInput = {
    organization: undefined,
    person: undefined,
  };

  switch (actor.kind) {
    case ActorTypeEnum.ActorOrganization: {
      const prunedActor = pruneInput(actor, ActorOrganizationInput);

      // The actors copied from a parent level carry what their display reads (the person of
      // each representative...): the nested inputs are pruned as well.
      actorInput = {
        organization: {
          ...prunedActor,
          references: prunedActor.references?.map(
            externalReferenceForm2ApiMapper,
          ),
          representatives: prunedActor.representatives.map(
            representativeForm2ApiMapper,
          ),
        },
      };

      break;
    }
    case ActorTypeEnum.ActorPerson: {
      const prunedActor = pruneInput(actor, ActorPersonInput);

      actorInput = {
        person: {
          ...prunedActor,
          references: prunedActor.references?.map(
            externalReferenceForm2ApiMapper,
          ),
        },
      };

      break;
    }
    default: {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unknown actor type: ${actor.kind}`);
    }
  }

  return actorInput;
}
